window.fspUtils = {

  defaultDPI: 150,

  convertFileStackUrlToJpg: function (url) {
  if (url){
    return "https://process.filestackapi.com/output=f:jpg,density:150/"  + url.substring(url.lastIndexOf('/')+1);
    }
  },

  cacheAndConvertFileStackUrlToJpg: function (url) {
   if (url)
   {
    return "https://process.filestackapi.com/cache=expiry:max/output=f:jpg,density:150/"  + url.substring(url.lastIndexOf('/')+1);
    }
  },

  rawUrl: function (url) {
    return "https://cdn.filestackcontent.com/"  + url.substring(url.lastIndexOf('/')+1);
  },

  getSideSelect: function () {
    if ($('select[name="properties[Sides]"]').length) {
      return $('select[name="properties[Sides]"]');
    } else if ($('select[name^="properties[Front"]').length) {
      return $('select[name^="properties[Front"]');
    }
    return null;
  },

  getCurrentSide: function () {
    var $select = window.fspUtils.getSideSelect();
    return $select ? $select.val() : '';
  },

  getSingleOrDoubleSelect: function () {
    if ($('select[name^="properties[Single"]').length) {
      return $('select[name^="properties[Single"]');
    }
    if ($('select[name^="properties[Sides"]').length) {
      return $('select[name^="properties[Sides"]');
    }
    return null;
  },

  getSingleOrDouble: function () {
    var $select = window.fspUtils.getSingleOrDoubleSelect();
    return $select ? $select.val() : '';
  },

  getPaperSelect: function () {
    var $paperSelect = $('select[name="properties[Envelope Paper]"]');
    if ($paperSelect.length) {
      return $paperSelect;
    }

    $paperSelect = null;
    var $selectorWrappers = $('.selector-wrapper');
    $selectorWrappers.each(function() {
      var $wrapper = $(this);
      if ($wrapper.children('label').text() == 'Envelope Paper') {
        var $select = $wrapper.children('select.single-option-selector');
        if ($select.length) {
          $paperSelect = $select;
          return false;
        }
      }
    });

    return $paperSelect;
  },

  getRoundedCornersSelect: function () {
    return $('select[name="properties[Rounded Corners]"]');
  },

  getImageDPI(url, callback) {
    var image = new Image();

    image.onload = function() {
      EXIF.getData(image, function() {
        var dpi = EXIF.getTag(this, 'XResolution') || EXIF.getTag(this, 'YResolution') || window.fspUtils.defaultDPI;
        callback(url, dpi);
      });
    };
    image.onerror = function() {
      callback(url, window.fspUtils.defaultDPI);
    };

    image.src = window.fspUtils.rawUrl(url);
  },

  setImage: function($divForImg, url, isLandscape = false) {
    var currentContainerWidth = window.containerSize.width;
    if (isLandscape) {
      currentContainerWidth = window.containerSize.height;
    }

    if (!currentContainerWidth) {
      console.error('image container size in inches not defined in window.containerSize');
      return;
    }

    // Show loading spinner before starting image load process and then hide it after loaded
    $divForImg.siblings('.loading-spinner').removeClass('hidden');
    window.fspUtils.getImageDPI(url, function(url, dpi) {
      $divForImg.css('background-image', 'url(' + url + ')')
        .css('transform', 'scale(' + ($divForImg.parent().width() / currentContainerWidth / dpi) + ')')
        .removeClass('hidden');

      // Hide spinner after 0.5s to give img element to display image
      setTimeout(function() {
        $divForImg.siblings('.loading-spinner').addClass('hidden');
      }, 500);
    });
  },

  setImageForMultipartProduct: function(index, url, isLandscape = false) {
    var containerInches = isLandscape ?
      (typeof lb_image1 !== 'undefined' ? lb_image1.height : multipartImages[index].height) :
      (typeof lb_image1 !== 'undefined' ? lb_image1.width : multipartImages[index].width);

    if (!containerInches) {
      console.error('Failed to set image as multipart container width in inches is zero (none of lb_image1 or multipartImages not defined)');
      return;
    }

    window.fspUtils.getImageDPI(url, function(url, dpi) {
      var $divForImg = $('#upload-part' + index).children('div.image');
      $divForImg.css('background-image', 'url(' + url + ')')
        .css('transform', 'scale(' + ($divForImg.parent().width() / containerInches / dpi) + ')')
        .removeClass('hidden');
    });
  },

  updateImageScaleForMultipartProduct: function(index, isLandscape = false) {
    var containerInches = isLandscape ?
      (typeof lb_image1 !== 'undefined' ? lb_image1.height : multipartImages[index].height) :
      (typeof lb_image1 !== 'undefined' ? lb_image1.width : multipartImages[index].width);

    if (!containerInches) {
      console.error('Failed to set image as multipart container width in inches is zero (none of lb_image1 or multipartImages not defined)');
      console.error('Error occurred for image index:', index);
      return;
    }

    window.fspUtils.getImageDPI(url, function(url, dpi) {
      var $divForImg = $('#upload-part' + index).children('div.image');
      $divForImg.css('transform', 'scale(' + ($divForImg.parent().width() / containerInches / dpi) + ')');
    });
  },

  updateImageScalesForMultipartProduct: function(count, isLandscape = false) {
    for (var i = 0; i < count; i += 1) {
      window.fspUtils.updateImageScaleForMultipartProduct(i, isLandscape);
    }
  },
  
  changeMultipleUploadSlotCount: function() {
  /* This function is for changing number of upload slots in multiple upload template when
   * customer chooses single-sided or double-sided option.
   */
    if (!window.uploadCountFrontOnly || window.uploadCountFrontOnly >= window.uploadCount) {
      return;
    }

    var showAllSlots = (
      window.fspUtils.getCurrentSide().toLowerCase().indexOf('double') >= 0 ||
      window.fspUtils.getCurrentSide().toLowerCase().indexOf('back black') >= 0
    );

    for (var i = window.uploadCountFrontOnly; i < window.uploadCount; i += 1) {
      $('.product-image-thumbs .product-image-thumb-wrapper').eq(i).css('display', showAllSlots ? 'block' : 'none');
    }
  },
  
  // TODO: fix this function to correct janky fix of 3/4 foil upload
  
//   visibleMultipleUploadSlotCount: function() {
//     if (!window.uploadCountFrontOnly || window.uploadCountFrontOnly >= window.uploadCount) {
//       return window.uploadCount;
//     }

//     if (window.fspUtils.getCurrentSide().toLowerCase().indexOf('double') >= 0) {
//       return window.uploadCount;
//     }
    
//     if (window.fspUtils.getCurrentSide().toLowerCase().indexOf('single') >= 0) {
// 		window.uploadCount = 3;
//       	return window.uploadCount;
//     }

//     return window.uploadCountFrontOnly;
//   },


};
